<template>
  <v-dialog v-model="showDialog" persistent transition="dialog-transition" max-width="290">
    <v-card>
      <v-card-title class="headline">{{ product.name }}: {{ product.quantity }}</v-card-title>

      <v-form ref="form" @submit.prevent v-model="valid" lazy-validation>
        <v-textarea
          v-model="narrative"
          autofocus
          label="Narrative"
          :rules="narrativeRules"
          color="primary darken-4"
          dense
          outlined
          hint="State reason for quantity update."
          persistent-hint
          validate-on-blur
          :rows="1"
          class="mx-6"
          @input="updateIsSaved"
          auto-grow
        ></v-textarea>

        <v-text-field
          v-model.number="addQuantity"
          type="number"
          :rules="quantityRules"
          color="success"
          dense
          outlined
          style="width: 150px;"
          class="mx-auto"
          @input="updateIsSaved"
        >
          <template v-slot:prepend>
            <v-icon color="success">mdi-tag-plus</v-icon>
          </template>
        </v-text-field>

        <v-text-field
          v-model.number="removeQuantity"
          type="number"
          :rules="quantityRules"
          color="error"
          dense
          outlined
          style="width: 150px;"
          class="mx-auto"
          @input="updateIsSaved"
        >
          <template v-slot:prepend>
            <v-icon color="error">mdi-tag-minus</v-icon>
          </template>
        </v-text-field>
      </v-form>

      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn text color="grey darken-1" @click="closeDialog()" class="text-capitalize">Cancel</v-btn>

        <v-btn
          text
          color="primary darken-4"
          @click="saveQuantity()"
          class="text-capitalize"
          :loading="isSaving"
          :disabled="isSaved"
        >Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "EditProductQuantityDialog",

  data() {
    return {
      valid: true,
      narrative: "",
      narrativeRules: [v => !!v || "A narrative is required"],
      addQuantity: 0,
      removeQuantity: 0,
      price: null,
      isSaved: true,
      isSaving: false
    };
  },

  components: {},

  methods: {
    closeDialog() {
      this.narrative = "";
      this.addQuantity = 0;
      this.removeQuantity = 0;
      this.$store.commit("setEditProductQuantityDialog", false);
    },

    saveQuantity() {
      if (this.$refs.form.validate()) {
        this.isSaving = true;
        this.$store
          .dispatch("changeProductQuantity", {
            productId: this.$store.state.products.product.id,
            data: {
              add: this.addQuantity,
              remove: this.removeQuantity,
              narrative: this.narrative
            }
          })
          .then(() => {
            this.isSaved = true;
            this.closeDialog();
          })
          .finally(() => {
            this.isSaving = false;
          });
      }
    },

    updateIsSaved() {
      this.isSaved = false;
    }
  },

  watch: {},

  computed: {
    showDialog() {
      return this.$store.state.products.editProductQuantityDialog;
    },

    product() {
      return this.$store.state.products.product;
    },

    quantityRules() {
      const rules = [];

      const rule1 = v => v !== "" || "Enter a number";
      rules.push(rule1);
      const rule2 = v => v >= 0 || "Quantity must be a non-negative number";
      rules.push(rule2);

      return rules;
    }
  }
};
</script>

<style>
</style>